/**
 * 图片URL处理工具
 * 用于将后端返回的相对路径拼接成完整URL
 */

// 获取API域名
const getApiDomain = () => {
  return 'https://zyimg.rongyuejiaoyu.com'
}

/**
 * 将相对路径转换为完整URL
 * @param {string} path - 图片路径（可以是相对路径或完整URL）
 * @param {string} defaultImage - 默认图片（可选）
 * @returns {string} - 完整的图片URL
 */
export function getImageUrl(path, defaultImage = '') {
  // 如果路径为空，返回默认图片
  if (!path || path === '' || path === null || path === undefined) {
    return defaultImage
  }

  // 如果已经是完整URL（http://或https://开头），直接返回
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path
  }

  // 如果是base64图片，直接返回
  if (path.startsWith('data:image')) {
    return path
  }

  // 获取API域名
  const domain = getApiDomain()

  // 如果路径以 / 开头，直接拼接
  if (path.startsWith('/')) {
    return `${domain}${path}`
  }

  // 否则在中间加上 /
  return `${domain}/${path}`
}

/**
 * 批量处理图片URL
 * @param {Array<string>} paths - 图片路径数组
 * @param {string} defaultImage - 默认图片（可选）
 * @returns {Array<string>} - 完整的图片URL数组
 */
export function getImageUrls(paths, defaultImage = '') {
  if (!Array.isArray(paths)) {
    return []
  }
  return paths.map(path => getImageUrl(path, defaultImage))
}

/**
 * 获取缩略图URL（如果后端支持缩略图参数）
 * @param {string} path - 图片路径
 * @param {Object} options - 缩略图选项
 * @param {number} options.width - 宽度
 * @param {number} options.height - 高度
 * @param {string} options.mode - 裁剪模式
 * @returns {string} - 完整的图片URL
 */
export function getThumbnailUrl(path, options = {}) {
  const url = getImageUrl(path)
  if (!url) return ''

  // 如果后端支持缩略图参数，可以在这里添加查询参数
  // 例如：return `${url}?width=${options.width}&height=${options.height}`
  return url
}

// 默认导出
export default {
  getImageUrl,
  getImageUrls,
  getThumbnailUrl
}

